var exports = {
  "iE": "xaee3c4fa--50de91--wrapper",
  "Mf": "xaee3c4fa--50de91--tab",
  "A1": "xaee3c4fa--50de91--_active",
  "su": "xaee3c4fa--50de91--icon-wrapper",
};

module.exports = exports;
